import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
const gallerySliders = document.querySelectorAll('[data-slider-gallery]');

import '../../../../node_modules/swiper/swiper.min.css';
import '../../../../node_modules/swiper/modules/navigation/navigation.min.css';
import '../../../../node_modules/swiper/modules/effect-fade/effect-fade.min.css';

const locationSlider = new Swiper('#locationSlider', {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    autoplay: {
        delay: 2000,
    },
    speed: 2000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    navigation: {
        prevEl: '#locationSliderPrev',
        nextEl: '#locationSliderNext'
    }
});

const architectureSlider = new Swiper('#architectureSlider', {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    autoplay: {
        delay: 2000,
    },
    speed: 2000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    navigation: {
        prevEl: '#architectureSliderPrev',
        nextEl: '#architectureSliderNext'
    }
});

[...gallerySliders].forEach((slider) => {
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');

    const gallerySlider = new Swiper(slider, {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        autoplay: {
            delay: 2000,
        },
        speed: 2000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
        }
    })
});


const awardSlider = new Swiper('#awardSlider', {
    modules: [Navigation, Autoplay],
    autoplay: {
        delay: 2000,
    },
    speed: 2000,
    loop: true,
    slidesPerView: 1,
    navigation: {
        prevEl: '#awardSliderPrev',
        nextEl: '#awardSliderNext'
    },
    breakpoints: {
        560: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 3
        },
        992: {
            slidesPerView: 4
        }
    }
});

const hpAwardSlider = new Swiper('#hpAwardSlider', {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    autoplay: {
        delay: 2000,
    },
    speed: 2000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    loop: true,
    navigation: {
        prevEl: '#hpAwardSliderPrev',
        nextEl: '#hpAwardSliderNext'
    }
});